export default __webpack_public_path__ + "static/tag-do-1-light-8c7df2e969d58e5ced78d07444bc2c1612b8cd48744a2b02cca587ff986e4340.png";